/*
 * LF Smart Cart · LeadFluence
 * Carrito lateral autónomo para NOEMOTIONS.
 * Deduce categoría, drop, set y básicos a partir de los datos de Shopify (sin etiquetas)
 * y recomienda 4 productos en la talla del cliente, ordenados de menor a mayor precio.
 */
(function () {
  'use strict';

  var root = document.getElementById('lf-cart');
  if (!root || window.__lfCartLoaded) return;
  window.__lfCartLoaded = true;

  // ------------------------------------------------------------------ datos
  function readJSON(id, fallback) {
    try { return JSON.parse(document.getElementById(id).textContent); } catch (e) { return fallback; }
  }
  var CONFIG = readJSON('lf-cart-config', {});
  var RAW = readJSON('lf-cart-catalog', []);
  var BEST = readJSON('lf-cart-bestsellers', []);

  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  var ONE_SIZE = /^(one size|talla única|unica|única|os|u)$/i;
  var CAT_RULES = [
    [/LONGSLEEVE|LONG SLEEVE/i, 'longsleeve', 'top'],
    [/\bTEE\b|T-SHIRT|TSHIRT|CAMISETA/i, 'tee', 'top'],
    [/SHIRT|CAMISA/i, 'shirt', 'top'],
    [/ZIP/i, 'zip', 'top'],
    [/HOODIE|CREWNECK|SWEAT|SUDADERA/i, 'hoodie', 'top'],
    [/KNIT|JERSEY|POLO/i, 'knit', 'top'],
    [/JACKET|WINDBRAKER|WINDBREAKER|PUFFER|CHAQUETA/i, 'jacket', 'outer'],
    [/JORTS|SHORTS/i, 'jorts', 'bottom'],
    [/PANTS|CARGO|JEANS|TROUSERS|PANTAL/i, 'pants', 'bottom'],
    [/SOCKS|CALCETIN/i, 'socks', 'acc'],
    [/CAP|BEANIE|HAT|GORRA/i, 'cap', 'acc'],
    [/TOTE|BAG|BOLSA/i, 'bag', 'acc'],
    [/CLOGS|SNEAKER|SHOES|ZAPATILLA/i, 'shoes', 'acc']
  ];
  var COMPLEMENT = { top: ['bottom', 'outer', 'acc'], outer: ['bottom', 'top', 'acc'], bottom: ['top', 'outer', 'acc'], acc: ['top', 'bottom'] };
  // Probabilidad de que se compre una segunda unidad de la misma categoría
  var AFFINITY = { tee: 1, longsleeve: 0.6, shirt: 0.4, hoodie: 0.3, zip: 0.3, knit: 0.3, pants: 0.15, jorts: 0.15, jacket: 0.05, socks: 0, cap: 0.1, bag: 0, shoes: 0 };
  var STOP = { THE: 1, I: 1, A: 1, EL: 1, LA: 1, NOE: 1, NOEMOTIONS: 1 };

  function matchRule(text) {
    for (var i = 0; i < CAT_RULES.length; i++) {
      if (CAT_RULES[i][0].test(text)) return { cat: CAT_RULES[i][1], role: CAT_RULES[i][2] };
    }
    return null;
  }
  // 1) El nombre y el tipo de producto. 2) Si no dicen qué es (por ejemplo "I <3 MISTAKES"), las colecciones
  //    de la propia tienda que son de un tipo de prenda ("T-SHIRTS", "HOODIES", "PANTS"…): solo las de 1–2 palabras,
  //    para no confundirse con colecciones de campaña ("NEW ARRIVALS - cereal tee"). Si dos colecciones dicen
  //    tipos distintos, gana la que coincide con más colecciones.
  function inferCategory(p) {
    var byName = matchRule(p.title + ' ' + (p.type || ''));
    if (byName) return byName;
    var votes = {}, best = null;
    (p.collections || []).forEach(function (title) {
      var t = String(title || '').trim();
      if (!t || t.split(/\s+/).length > 2) return;
      var m = matchRule(t);
      if (!m) return;
      votes[m.cat] = (votes[m.cat] || { n: 0, m: m });
      votes[m.cat].n++;
      if (!best || votes[m.cat].n > votes[best].n) best = m.cat;
    });
    return best ? votes[best].m : { cat: 'other', role: 'top' };
  }
  function firstWord(title) {
    var words = title.toUpperCase().split(/\s+/);
    for (var i = 0; i < words.length; i++) if (!STOP[words[i]] && /[A-Z]/.test(words[i])) return words[i];
    return title.toUpperCase();
  }
  function sizeOptionIndex(p) {
    for (var i = 0; i < (p.options || []).length; i++) {
      var ok = p.variants.every(function (v) {
        var val = String(v.options[i] || '').toUpperCase();
        return SIZE_ORDER.indexOf(val) >= 0 || ONE_SIZE.test(val) || /^\d{2}(\.5)?$/.test(val);
      });
      if (ok) return i;
    }
    return -1;
  }

  function buildCatalog(raw) {
    var prods = raw.map(function (p) {
      var c = inferCategory(p);
      var si = sizeOptionIndex(p);
      var one = si < 0 || p.variants.length === 1 || p.variants.every(function (v) { return ONE_SIZE.test(String(v.options[si] || '')); });
      return Object.assign({}, p, c, { sizeIdx: si, one: one, ts: p.published * 1000, family: firstWord(p.title) });
    });
    // Básicos de puente: menos de la mitad del precio mediano de lo disponible (calcetines, gorras…)
    var prices = prods.filter(function (p) { return p.available; }).map(function (p) { return p.price; }).sort(function (a, b) { return a - b; });
    var median = prices.length ? prices[Math.floor(prices.length / 2)] : 0;
    var isBasic = function (p) { return median > 0 && p.price <= median * 0.45; };
    // Drops: lo publicado en la misma tanda (menos de 90 min entre productos) es el mismo drop.
    // Los básicos no cuentan: publicar unos calcetines no es un drop y no debe restar novedad al drop real.
    var sorted = prods.filter(function (p) { return !isBasic(p); }).sort(function (a, b) { return a.ts - b.ts; });
    var dropIdx = 0, last = null, dropOf = {};
    sorted.forEach(function (p) { if (last !== null && p.ts - last > 90 * 60 * 1000) dropIdx++; dropOf[p.id] = dropIdx; last = p.ts; });
    // Sets: misma primera palabra y más de una categoría
    var famCats = {};
    prods.forEach(function (p) { (famCats[p.family] = famCats[p.family] || {})[p.cat] = 1; });
    var bestRank = {};
    BEST.forEach(function (id, i) { bestRank[id] = i; });
    var newestDrop = dropIdx;
    return prods.map(function (p) {
      var evergreen = isBasic(p);
      var age = evergreen ? 0 : newestDrop - dropOf[p.id];
      return Object.assign(p, {
        evergreen: evergreen,
        drop: evergreen ? -1 : dropOf[p.id],
        isSet: Object.keys(famCats[p.family]).length > 1,
        novelty: evergreen ? 0.3 : age === 0 ? 1 : age === 1 ? 0.6 : 0.25,
        pop: bestRank[p.id] != null ? 1 - bestRank[p.id] / Math.max(BEST.length, 1) : null
      });
    });
  }

  var CATALOG = buildCatalog(RAW);
  var BY_ID = {};
  CATALOG.forEach(function (p) { BY_ID[p.id] = p; });

  function variantFor(p, size) {
    if (p.one) return p.variants.find(function (v) { return v.available; }) || null;
    return p.variants.find(function (v) { return String(v.options[p.sizeIdx]).toUpperCase() === size && v.available; }) || null;
  }
  function sizesOf(p) {
    if (p.one) return [];
    var seen = {}, list = [];
    p.variants.forEach(function (v) {
      var s = String(v.options[p.sizeIdx]).toUpperCase();
      if (!seen[s]) { seen[s] = 1; list.push({ size: s, available: v.available, qty: v.qty }); }
      else if (v.available) list.find(function (x) { return x.size === s; }).available = true;
    });
    return list;
  }
  function qtyIn(p, size) {
    var v = variantFor(p, size);
    return v ? Math.max(v.qty, 0) : 0;
  }

  // ------------------------------------------------------------------ señales de navegación
  var VIEW_KEY = 'lf_cart_viewed';
  function getViewed() {
    try { return JSON.parse(localStorage.getItem(VIEW_KEY)) || []; } catch (e) { return []; }
  }
  (function trackView() {
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (!meta || !meta.id) return;
      var list = getViewed().filter(function (id) { return id !== meta.id; });
      list.unshift(meta.id);
      localStorage.setItem(VIEW_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) { /* sin almacenamiento: se ignora */ }
  })();

  // ------------------------------------------------------------------ utilidades
  // Prices are shown in the customer's currency (EUR, GBP, USD, CHF, SEK...), taken live from the cart
  var formatters = {};
  function currency() { return (state.cart && state.cart.currency) || CONFIG.currency || 'EUR'; }
  function formatter(round) {
    var key = currency() + (round ? '-r' : '');
    if (!formatters[key]) {
      try {
        formatters[key] = new Intl.NumberFormat('en-IE', round ? { style: 'currency', currency: currency(), maximumFractionDigits: 0, minimumFractionDigits: 0 } : { style: 'currency', currency: currency() });
      } catch (e) { formatters[key] = { format: function (n) { return n.toFixed(round ? 0 : 2) + ' ' + currency(); } }; }
    }
    return formatters[key];
  }
  function fmt(cents) { return formatter(false).format(cents / 100); }
  function fmtRound(cents) { return formatter(true).format(Math.round(cents / 100)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  // Thresholds are set in EUR (like the shipping rates in Shopify) and converted to the customer's currency
  function threshold() {
    var eur;
    if (CONFIG.thresholdOverride != null && !isNaN(CONFIG.thresholdOverride)) eur = Number(CONFIG.thresholdOverride);
    else {
      var t = (CONFIG.thresholds || {})[CONFIG.country];
      eur = t != null ? t : (CONFIG.defaultThreshold || 100);
    }
    var rate = 1;
    try {
      var c = window.Shopify && window.Shopify.currency;
      if (c && c.active && c.active !== 'EUR' && Number(c.rate) > 0) rate = Number(c.rate);
    } catch (e) { /* default rate 1 */ }
    return Math.round(eur * rate) * 100;
  }

  // ------------------------------------------------------------------ API del carrito
  var internal = 0;
  function api(url, body) {
    internal++;
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        internal--;
        if (!r.ok) throw data;
        return data;
      });
    }, function (err) { internal--; throw err; });
  }
  function getCart() { return api('/cart.js'); }

  // ------------------------------------------------------------------ estado
  var state = { cart: null, openLine: null, busy: false, error: '', pending: null, adding: null };

  function syncTheme(cart) {
    try { document.dispatchEvent(new CustomEvent('cart.requestComplete', { detail: cart })); } catch (e) { /* noop */ }
    document.querySelectorAll('.cart-count-number').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-count', cart.item_count);
    });
  }
  function refresh() {
    return getCart().then(function (cart) { state.cart = cart; syncTheme(cart); render(); return cart; });
  }
  // Traduce los avisos de Shopify a un mensaje claro en español
  // Each message says what happened and what the customer can do next
  function friendlyError(err, ctx) {
    ctx = ctx || {};
    var raw = String((err && (err.description || err.message)) || '');
    var isStock = /availab|stock|inventory|only \d+|sold out|agotad/i.test(raw);
    var inSize = ctx.size ? ' in size ' + ctx.size : '';
    if (!isStock) return 'We couldn\u2019t update your cart. Please try again.';
    if (ctx.type === 'inc') {
      if (ctx.left === 1) return 'You already have the last unit' + inSize + ' in your cart.';
      if (ctx.left > 1) return 'You already have all ' + ctx.left + ' units left' + inSize + ' in your cart.';
      return 'There are no more units available' + inSize + '.';
    }
    if (ctx.type === 'swap') return 'Size ' + (ctx.size || '') + ' just sold out. Please choose another size.';
    if (ctx.type === 'add') return 'Sorry, ' + (ctx.title || 'this item') + inSize + ' just sold out. Try another size.';
    return 'Sorry, this item just sold out.';
  }
  var errorTimer = null;
  // /cart/change.js ya devuelve el carrito entero: si lo tenemos, pintamos con él y nos ahorramos otra petición
  function act(promise, ctx) {
    state.busy = true; state.error = ''; root.classList.add('is-busy');
    return promise.then(function (data) {
      if (data && Array.isArray(data.items) && data.item_count != null) {
        state.cart = data; syncTheme(data); state.pending = null; state.adding = null; render(); return data;
      }
      state.pending = null; state.adding = null;
      return refresh();
    }, function (err) {
      state.error = friendlyError(err, ctx);
      state.pending = null; state.adding = null;
      clearTimeout(errorTimer);
      errorTimer = setTimeout(function () { state.error = ''; render(); }, 5000);
      return refresh();
    }).then(function () { state.busy = false; root.classList.remove('is-busy'); });
  }
  // Unidades que quedan de la variante de una línea (null si la tienda no controla stock)
  function stockLeft(it) {
    var p = BY_ID[it.product_id];
    if (!p) return null;
    var v = p.variants.find(function (x) { return x.id === it.variant_id; });
    if (!v || v.qty <= 0) return null;
    return v.qty;
  }

  // ------------------------------------------------------------------ motor de recomendaciones
  // Talla del cliente, por separado para ropa (XS…XXXL) y calzado (39, 40…): unos zuecos no deben
  // hacer que el carrito busque camisetas en "talla 40". Si no se conoce, es null.
  function isNumSize(s) { return /^\d{2}(\.5)?$/.test(s); }
  function cartSizes(cart) {
    var out = { alpha: null, num: null };
    for (var i = cart.items.length - 1; i >= 0; i--) {
      var p = BY_ID[cart.items[i].product_id];
      if (!p || p.one) continue;
      var s = String(cart.items[i].variant_options[p.sizeIdx] || '').toUpperCase();
      if (isNumSize(s)) { if (!out.num) out.num = s; }
      else if (SIZE_ORDER.indexOf(s) >= 0) { if (!out.alpha) out.alpha = s; }
    }
    return out;
  }
  function sizeFor(p, sizes) {
    if (p.one) return '';
    var sample = String(p.variants[0].options[p.sizeIdx] || '').toUpperCase();
    return isNumSize(sample) ? sizes.num : sizes.alpha;
  }

  function recommend(cart) {
    var thr = threshold();
    var subtotal = cart.total_price;
    var gap = Math.max(0, thr - subtotal);
    var sizes = cartSizes(cart);
    var viewed = getViewed();
    var inCart = {}, drops = {}, roles = {}, fams = {}, cats = {};
    cart.items.forEach(function (it) {
      var p = BY_ID[it.product_id];
      if (!p) return;
      inCart[p.id] = 1; drops[p.drop] = 1; roles[p.role] = 1; fams[p.family] = 1; cats[p.cat] = 1;
    });
    var nearGap = thr * 0.25; // "close to free shipping" = within 25% of the threshold
    var W = gap === 0 ? { rel: 0.5, gap: 0, nav: 0.15, nov: 0.13, pop: 0.12, stock: 0.1 }
      : gap <= nearGap ? { rel: 0.17, gap: 0.45, nav: 0.12, nov: 0.09, pop: 0.09, stock: 0.08 }
      : { rel: 0.38, gap: 0.22, nav: 0.14, nov: 0.09, pop: 0.09, stock: 0.08 };
    // Si nadie tiene datos de ventas (drop recién salido) su peso se reparte
    var anyPop = CATALOG.some(function (p) { return p.available && p.pop != null; });
    if (!anyPop) { W.rel += W.pop / 2; W.nov += W.pop / 2; W.pop = 0; }

    var scored = CATALOG.filter(function (p) {
      if (!p.available || inCart[p.id]) return false;
      // Prendas que casi nadie repite en un mismo pedido (chaqueta, calcetines, bolsa, calzado): nunca otra igual
      if (cats[p.cat] && (AFFINITY[p.cat] || 0) < 0.1) return false;
      var sz = sizeFor(p, sizes);
      // Talla conocida: solo si queda en su talla. Talla desconocida: si queda en alguna (el "+" lleva a la ficha)
      return p.one || (sz ? !!variantFor(p, sz) : true);
    }).map(function (p) {
      var size = sizeFor(p, sizes);
      var comp = Object.keys(roles).some(function (r) { return (COMPLEMENT[r] || []).indexOf(p.role) >= 0; });
      var rel = 0.2;
      if (p.evergreen) rel = 0.6;
      else if (p.isSet && fams[p.family] && !cats[p.cat]) rel = 1;
      else if (drops[p.drop] && comp) rel = 0.85;
      else if (comp) rel = 0.65;
      else if (drops[p.drop]) rel = 0.45;
      if (cats[p.cat]) rel = Math.max(rel * 0.5, (AFFINITY[p.cat] || 0) * 0.8);
      var g = 0.5;
      if (gap > 0) g = p.price >= gap ? 1 - Math.min(1, (p.price - gap) / (thr * 0.7)) : (p.price / gap) * 0.35;
      var nav = viewed.indexOf(p.id) >= 0 ? 1 : 0;
      var low = !p.one && !!size && qtyIn(p, size) > 0 && qtyIn(p, size) <= 3;
      var pop = p.pop == null ? 0.3 : p.pop;
      var score = W.rel * rel + W.gap * g + W.nav * nav + W.nov * p.novelty + W.pop * pop + W.stock * (low ? 0.5 : 0);
      return { p: p, size: size, score: score, low: low, sameSet: rel === 1, viewed: nav === 1 };
    }).sort(function (a, b) { return b.score - a.score; });

    // ---- Selección y orden con intención ------------------------------------------------
    // Bloques, en este orden:
    //  1) Las piezas de su mismo conjunto (si quedan en su talla).
    //  2) Una prenda de cada tipo (la de más puntos de cada tipo: ahí cuenta lo que ha mirado), de menor a mayor.
    //  3) El producto puente (calcetines, gorras…: cualquier producto que cueste menos del 45 % del precio
    //     mediano de la tienda). Está OCULTO y solo aparece cuando hace falta:
    //     - le falta poco y un puente, por sí solo, le da el envío gratis: el más barato que llega, con "Free shipping";
    //     - en cualquier otro caso (le falta mucho, ya tiene el envío gratis o ningún puente llega): no se muestra.
    //  4) El resto, de menor a mayor. Máximo 12 en total, 3 por tipo y un solo básico.
    var MAX_RECS = 12;
    var mode = gap === 0 ? 'free' : gap <= nearGap ? 'unlock' : 'look';
    var byPrice = function (a, b) { return a.p.price - b.p.price; };
    var addable = function (x) { return x.p.one || !!x.size; };

    var basics = scored.filter(function (x) { return x.p.evergreen && addable(x); });
    var pool = scored.filter(function (x) { return !x.p.evergreen; });
    var setPart = pool.filter(function (x) { return x.sameSet && addable(x); }).sort(byPrice);
    // Lo que ha mirado y no ha añadido: las 2 últimas prendas vistas (en su talla) pasan delante.
    // Solo por dentro: nunca se le dice "lo has visto".
    var viewedPicks = [];
    viewed.forEach(function (id) {
      if (viewedPicks.length >= 2) return;
      var x = pool.find(function (y) { return y.p.id === id && !y.sameSet && addable(y); });
      if (x) viewedPicks.push(x);
    });

    // Ropa elegida por puntos: primero lo que se puede añadir en su talla, después (si faltan) el resto
    var perCat = {}, chosen = [];
    setPart.forEach(function (x) { perCat[x.p.cat] = (perCat[x.p.cat] || 0) + 1; });
    var take = function (x) {
      if (chosen.length + setPart.length >= MAX_RECS - 1 || chosen.indexOf(x) >= 0 || (perCat[x.p.cat] || 0) >= 3) return;
      chosen.push(x); perCat[x.p.cat] = (perCat[x.p.cat] || 0) + 1;
    };
    viewedPicks.forEach(function (x) { chosen.push(x); perCat[x.p.cat] = (perCat[x.p.cat] || 0) + 1; });
    pool.forEach(function (x) { if (!x.sameSet && addable(x)) take(x); });
    pool.forEach(function (x) { if (!x.sameSet && !addable(x)) take(x); });

    var seenCat = {}, firstPart = [];
    viewedPicks.forEach(function (x) { seenCat[x.p.cat] = 1; });
    chosen.forEach(function (x) { if (!seenCat[x.p.cat] && addable(x)) { seenCat[x.p.cat] = 1; firstPart.push(x); } });
    firstPart.sort(byPrice);
    var tail = chosen.filter(function (x) { return firstPart.indexOf(x) < 0 && viewedPicks.indexOf(x) < 0; }).sort(byPrice);

    var basicsByPrice = basics.slice().sort(byPrice);
    var basic = null;
    if (mode === 'unlock') {
      basic = basicsByPrice.find(function (x) { return x.p.price >= gap; }) || null;
    } else if (mode === 'look') {
      basic = null; // le falta mucho: primero ropa que completa el look
    }

    // Lo más barato que, por sí solo, le da el envío gratis
    var opener = null;
    if (gap > 0) {
      opener = setPart.concat(viewedPicks, firstPart, basic ? [basic] : [], tail).filter(function (x) { return addable(x) && x.p.price >= gap; })
        .sort(byPrice)[0] || null;
      if (opener && opener.sameSet) opener = null; // el conjunto ya lleva su propia etiqueta
      if (opener && firstPart.indexOf(opener) < 0 && viewedPicks.indexOf(opener) < 0 && opener !== basic) {
        tail.splice(tail.indexOf(opener), 1);
        firstPart.push(opener); firstPart.sort(byPrice);
      }
    }

    var middle;
    if (mode === 'unlock') {
      // Lo que le da el envío gratis primero; después lo que ha mirado; después el resto de menor a mayor
      var rest = firstPart.concat(basic ? [basic] : []).sort(byPrice);
      var head = opener && viewedPicks.indexOf(opener) < 0 && rest.indexOf(opener) >= 0 ? [opener] : [];
      middle = head.concat(viewedPicks, rest.filter(function (x) { return head.indexOf(x) < 0; }));
    } else if (mode === 'look') {
      // Le falta mucho. Prioridad: 1) la segunda prenda (si lleva una prenda que se suele repetir, como una
      // camiseta: otra camiseta, mejor la que haya mirado); 2) lo que ha mirado; 3) una de cada tipo de menor a mayor.
      // El puente (calcetines…), al final del todo: es para el siguiente paso.
      var repeatCats = Object.keys(cats).filter(function (c) { return (AFFINITY[c] || 0) >= 0.6; });
      var isSecond = function (x) { return repeatCats.indexOf(x.p.cat) >= 0; };
      var second = viewedPicks.find(isSecond) || firstPart.find(isSecond) || null;
      middle = (second ? [second] : []).concat(
        viewedPicks.filter(function (x) { return x !== second; }),
        firstPart.filter(function (x) { return x !== second; }));
    } else {
      middle = viewedPicks.concat(firstPart);
    }
    // Sin repetidos y respetando el máximo de 3 por tipo y 12 en total
    var seen = {}, count = {};
    var picked = setPart.concat(middle, tail).filter(function (x) {
      if (seen[x.p.id] || (count[x.p.cat] || 0) >= 3) return false;
      seen[x.p.id] = 1; count[x.p.cat] = (count[x.p.cat] || 0) + 1; return true;
    }).slice(0, MAX_RECS);
    // Si el catálogo es muy corto, se completa hasta 4 como mínimo
    scored.forEach(function (x) { if (picked.length < 4 && picked.indexOf(x) < 0 && !x.p.evergreen) picked.push(x); });

    // Etiquetas con moderación: como mucho 2 en la fila y solo 1 de urgencia.
    // Prioridad: "Complete the set" > "Free shipping" > "Few left"
    var badges = 0, urgency = 0;
    picked.forEach(function (x) { x.badge = ''; });
    picked.forEach(function (x) { if (x.sameSet && badges < 2) { x.badge = 'Complete the set'; badges++; } });
    if (opener && picked.indexOf(opener) >= 0 && badges < 2) { opener.badge = 'Free shipping'; badges++; }
    picked.forEach(function (x) {
      if (x.badge || badges >= 2) return;
      if (x.low && urgency === 0) { x.badge = 'Few left · ' + x.size; urgency++; badges++; }
    });
    return {
      gap: gap, thr: thr, subtotal: subtotal, size: sizes.alpha || sizes.num, sizes: sizes, recs: picked,
      mode: mode
    };
  }

  // ------------------------------------------------------------------ render
  var els = {
    count: root.querySelector('[data-lfc-count]'),
    ship: root.querySelector('[data-lfc-ship]'),
    lines: root.querySelector('[data-lfc-lines]'),
    recs: root.querySelector('[data-lfc-recs]'),
    foot: root.querySelector('[data-lfc-foot]'),
    subtotals: root.querySelectorAll('[data-lfc-subtotal]'),
    shipline: root.querySelector('[data-lfc-shipline]')
  };

  function render() {
    var cart = state.cart;
    if (!cart) return;
    var r = recommend(cart);
    var n = cart.item_count;
    els.count.textContent = n === 1 ? '1 item' : n + ' items';

    var pct = Math.min(100, Math.round((r.subtotal / r.thr) * 100));
    els.ship.hidden = n === 0;
    els.ship.innerHTML =
      '<div class="lfc__ship-row"><p>' +
      (r.gap > 0 ? 'You\u2019re <strong>' + fmt(r.gap) + '</strong> away from free shipping' : '<strong>Free shipping</strong> unlocked') +
      '</p><span>' + fmtRound(r.subtotal) + ' / ' + fmtRound(r.thr) + '</span></div>' +
      '<div class="lfc__bar"><i style="width:' + pct + '%"></i></div>';

    if (n === 0) {
      els.lines.innerHTML = '<p class="lfc__empty">Your cart is empty</p>';
    } else {
      els.lines.innerHTML = (state.error ? '<p class="lfc__error" role="alert">' + esc(state.error) + '</p>' : '') +
        cart.items.map(function (it, i) { return lineHTML(it, i); }).join('');
    }

    if (n > 0 && r.recs.length) {
      els.recs.hidden = false;
      els.recs.innerHTML =
        '<div class="lfc__recs-head"><h3>' + (r.mode === 'free' ? 'Level up the fit' : 'Complete the fit') + '</h3>' +
        (r.sizes.alpha ? '<span>In your size ' + esc(r.sizes.alpha) + '</span>' : '') + '</div>' +
        '<div class="lfc__grid" data-lfc-track>' + r.recs.map(function (x, i) { return recHTML(x, i, r); }).join('') + '</div>' +
        '<div class="lfc__scroll" aria-hidden="true"><i data-lfc-thumb></i></div>';
      setupScroller();
    } else {
      els.recs.hidden = true;
      els.recs.innerHTML = '';
    }

    els.foot.hidden = n === 0;
    els.subtotals.forEach(function (el) { el.textContent = fmt(r.subtotal); });
    els.shipline.textContent = r.gap > 0 ? (CONFIG.shippingFromLabel || 'Calculated at checkout') : 'Free';
    els.shipline.classList.toggle('is-free', r.gap === 0);
  }

  function lineHTML(it, i) {
    var p = BY_ID[it.product_id];
    var sizeIdx = p ? p.sizeIdx : -1;
    var hasSize = p && !p.one && sizeIdx >= 0;
    var current = hasSize ? String(it.variant_options[sizeIdx]).toUpperCase() : '';
    var others = (it.options_with_values || []).filter(function (o, idx) { return idx !== sizeIdx && !/title/i.test(o.name); })
      .map(function (o) { return o.value; }).join(' · ');
    var open = state.openLine === i && hasSize;
    var left = stockLeft(it);
    var atMax = left != null && it.quantity >= left;
    var html = '<div class="lfc__line' + (state.pending === i ? ' is-updating' : '') + '" data-key="' + esc(it.key) + '">' +
      '<a href="' + esc(it.url) + '" class="lfc__line-img"><img src="' + esc(img(it.image, 240)) + '" alt="' + esc(it.product_title) + '" width="104" height="130" loading="lazy"></a>' +
      '<div class="lfc__line-info">' +
        '<div class="lfc__line-top"><a href="' + esc(it.url) + '" class="lfc__line-title">' + esc(it.product_title) + '</a>' +
        '<span class="lfc__line-price">' + (it.original_line_price > it.final_line_price ? '<s>' + fmt(it.original_line_price) + '</s> ' : '') + fmt(it.final_line_price) + '</span></div>' +
        (others ? '<span class="lfc__line-meta">' + esc(others) + '</span>' : '') +
        (atMax ? '<span class="lfc__line-note">' + (left === 1 ? 'Last one' : 'Only ' + left + ' left') + (hasSize ? ' in size ' + esc(current) : '') + '</span>' : '') +
        '<div class="lfc__line-actions">' +
          (hasSize
            ? '<button type="button" class="lfc__size-btn" data-act="toggle-size" data-i="' + i + '" aria-expanded="' + open + '" aria-label="Size ' + esc(current) + ', change size">' +
              '<span>Size</span><strong>' + esc(current) + '</strong>' +
              '<svg width="9" height="6" viewBox="0 0 9 6" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="' + (open ? 'M0.5 5 L4.5 1 L8.5 5' : 'M0.5 1 L4.5 5 L8.5 1') + '"/></svg></button>'
            : '') +
          '<div class="lfc__qty">' +
            '<button type="button" data-act="qty" data-i="' + i + '" data-d="-1" aria-label="Remove one">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-act="qty" data-i="' + i + '" data-d="1"' +
              (atMax ? ' disabled aria-label="No more units left in this size" title="No more units left in this size"' : ' aria-label="Add one"') + '>+</button>' +
          '</div>' +
          '<button type="button" class="lfc__remove" data-act="remove" data-i="' + i + '">Remove</button>' +
        '</div>' +
      '</div>';
    if (open) {
      html += '<div class="lfc__sizes" role="group" aria-label="Change size">' + sizesOf(p).map(function (s) {
        var active = s.size === current;
        var ok = s.available || active;
        return '<button type="button" data-act="swap" data-i="' + i + '" data-size="' + esc(s.size) + '"' +
          (ok ? '' : ' disabled') + (active ? ' aria-pressed="true" class="is-active"' : '') + '>' + esc(s.size) + '</button>';
      }).join('') + '</div>';
    }
    return html + '</div>';
  }

  function recHTML(x, i, r) {
    var p = x.p;
    // El "+" añade directamente en la talla del cliente (solo se recomiendan productos con esa talla disponible).
    // Si luego quiere otra talla, la cambia en la línea del carrito. Si no sabemos su talla
    // (por ejemplo, solo lleva calzado o talla única), el "+" lleva a la ficha para que la elija.
    var adding = state.adding === p.id;
    var plusIcon = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M5 0.5 V9.5 M0.5 5 H9.5"/></svg>';
    var plus;
    if (!p.one && !x.size) {
      plus = '<a class="lfc__plus" href="' + esc(p.url) + '" aria-label="' + esc('Choose a size for ' + p.title) + '" title="Choose your size"><span>' + plusIcon + '</span></a>';
    } else {
      var label = 'Add ' + p.title + (p.one ? '' : ' in size ' + x.size);
      plus = '<button type="button" class="lfc__plus' + (adding ? ' is-adding' : '') + '" data-act="add" data-id="' + p.id + '"' +
        (p.one ? '' : ' data-size="' + esc(x.size) + '"') + ' data-pos="' + i + '" aria-label="' + esc(label) + '" title="' + esc(label) + '"><span>' +
        (adding ? '<i class="lfc__spin" aria-hidden="true"></i>' : plusIcon) + '</span></button>';
    }
    return '<article class="lfc__card">' +
      '<div class="lfc__card-media">' +
        '<a href="' + esc(p.url) + '"><img src="' + esc(img(p.img, 360)) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
        (x.badge ? '<span class="lfc__badge' + (x.low && x.badge.indexOf('Few left') === 0 ? ' is-warn' : '') + '">' + esc(x.badge) + '</span>' : '') +
        plus +
      '</div>' +
      '<a href="' + esc(p.url) + '" class="lfc__card-title">' + esc(p.title) + '</a>' +
      '<span class="lfc__card-price">' + (p.compare > p.price ? '<s>' + fmt(p.compare) + '</s> <span class="is-sale">' + fmt(p.price) + '</span>' : fmt(p.price)) + '</span>' +
      '</article>';
  }

  // ------------------------------------------------------------------ carrusel: línea de progreso y arrastre con ratón
  var lastScroll = 0;
  // Arrastre libre con inercia: el carrusel sigue el ratón y frena suave, sin saltar de prenda en prenda
  var drag = { track: null, down: false, moved: false, startX: 0, startLeft: 0, lastX: 0, lastT: 0, v: 0, raf: 0 };
  function stopGlide() { if (drag.raf) { cancelAnimationFrame(drag.raf); drag.raf = 0; } }
  window.addEventListener('pointermove', function (e) {
    if (!drag.down || !drag.track) return;
    var dx = e.clientX - drag.startX;
    if (Math.abs(dx) > 4) { drag.moved = true; drag.track.classList.add('is-dragging'); }
    if (drag.moved) drag.track.scrollLeft = drag.startLeft - dx;
    var now = performance.now(), dt = now - drag.lastT;
    if (dt > 0) drag.v = 0.8 * ((e.clientX - drag.lastX) / dt) + 0.2 * drag.v;
    drag.lastX = e.clientX; drag.lastT = now;
  });
  window.addEventListener('pointerup', function () {
    if (!drag.down) return;
    drag.down = false;
    var t = drag.track;
    setTimeout(function () { if (t) t.classList.remove('is-dragging'); }, 0);
    // Si se soltó en movimiento, sigue deslizando y frena poco a poco
    var v = performance.now() - drag.lastT < 80 ? drag.v * 16 : 0;
    if (!t || Math.abs(v) < 1) return;
    stopGlide();
    (function glide() {
      t.scrollLeft -= v;
      v *= 0.94;
      drag.raf = Math.abs(v) > 0.5 ? requestAnimationFrame(glide) : 0;
    })();
  });
  function setupScroller() {
    var track = els.recs.querySelector('[data-lfc-track]');
    var thumb = els.recs.querySelector('[data-lfc-thumb]');
    if (!track || !thumb) return;
    track.scrollLeft = lastScroll;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var bar = thumb.parentNode;
      if (max <= 2) { bar.hidden = true; return; }
      bar.hidden = false;
      var ratio = track.clientWidth / track.scrollWidth;
      var pos = track.scrollLeft / max;
      thumb.style.width = (ratio * 100) + '%';
      thumb.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
      lastScroll = track.scrollLeft;
    }
    track.addEventListener('scroll', update, { passive: true });
    window.requestAnimationFrame(update);
    track.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', update, { once: true }); });

    // Arrastrar con el ratón en escritorio (en móvil y trackpad ya se desliza solo)
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      stopGlide();
      drag.track = track; drag.down = true; drag.moved = false; drag.startX = e.clientX; drag.startLeft = track.scrollLeft;
      drag.lastX = e.clientX; drag.lastT = performance.now(); drag.v = 0;
    });
    // El navegador no debe "coger" el enlace ni la foto al arrastrar: el carrusel se mueve solo con nuestro arrastre
    track.querySelectorAll('a, img').forEach(function (el) { el.setAttribute('draggable', 'false'); });
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // Un arrastre no debe contar como clic en el producto
    track.addEventListener('click', function (e) { if (drag.moved) { e.preventDefault(); e.stopPropagation(); drag.moved = false; } }, true);
    // La rueda vertical del ratón también mueve el carrusel
    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) > Math.abs(e.deltaX) && track.scrollWidth > track.clientWidth) {
        var atStart = track.scrollLeft <= 0 && e.deltaY < 0;
        var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 1 && e.deltaY > 0;
        if (!atStart && !atEnd) { e.preventDefault(); track.scrollLeft += e.deltaY; }
      }
    }, { passive: false });
  }

  // ------------------------------------------------------------------ acciones
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lfc-close]')) { close(); return; }
    var b = e.target.closest('[data-act]');
    if (!b || state.busy) return;
    var cart = state.cart;
    var i = Number(b.getAttribute('data-i'));
    var it = cart && cart.items[i];
    var act_ = b.getAttribute('data-act');

    if (act_ === 'toggle-size') { state.openLine = state.openLine === i ? null : i; render(); return; }
    if (act_ === 'qty') {
      state.openLine = null; state.pending = i; render();
      var lp = BY_ID[it.product_id];
      var lsize = lp && !lp.one ? String(it.variant_options[lp.sizeIdx]).toUpperCase() : '';
      act(api('/cart/change.js', { id: it.key, quantity: Math.max(0, it.quantity + Number(b.getAttribute('data-d'))) }),
        { type: 'inc', left: stockLeft(it), size: lsize });
      return;
    }
    if (act_ === 'remove') { state.openLine = null; state.pending = i; render(); act(api('/cart/change.js', { id: it.key, quantity: 0 })); return; }
    if (act_ === 'swap') {
      var p = BY_ID[it.product_id];
      var size = b.getAttribute('data-size');
      var v = p && variantFor(p, size);
      state.openLine = null;
      if (!v || v.id === it.variant_id) { render(); return; }
      // La talla nueva se ve al instante; por detrás se añade primero la nueva (si está agotada, la prenda
      // original no se pierde) y después se quita la antigua, que ya devuelve el carrito actualizado
      var oldKey = it.key, qty = it.quantity, props = it.properties || {};
      it.variant_options = it.variant_options.slice(); it.variant_options[p.sizeIdx] = size;
      state.pending = i; render();
      act(api('/cart/add.js', { items: [{ id: v.id, quantity: qty, properties: props }] }).then(function () {
        return api('/cart/change.js', { id: oldKey, quantity: 0 });
      }), { type: 'swap', size: size });
      return;
    }
    if (act_ === 'add') {
      var prod = BY_ID[Number(b.getAttribute('data-id'))];
      var variant = prod && variantFor(prod, b.getAttribute('data-size'));
      if (!variant) { render(); return; }
      var r = recommend(cart);
      state.adding = prod.id; render();
      act(api('/cart/add.js', { items: [{ id: variant.id, quantity: 1, properties: { _lf_rec: r.mode + '-' + b.getAttribute('data-pos') } }] }),
        { type: 'add', title: prod.title, size: prod.one ? '' : b.getAttribute('data-size') });
    }
  });

  // ------------------------------------------------------------------ abrir / cerrar
  var lastFocus = null;
  function open() {
    lastFocus = document.activeElement;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lfc-lock');
    root.classList.add('is-open');
    // Lo último que sabemos se pinta al instante (sin esqueleto vacío) y se actualiza por detrás
    if (state.cart) render();
    refresh();
    setTimeout(function () { root.querySelector('.lfc__panel').focus(); }, 30);
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lfc-lock');
    state.adding = null; state.openLine = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  // Botón "Cart" del header (y cualquier enlace a /cart dentro del header)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lf-cart-open], #header .cart-button, #header .cartc, header a[href="/cart"]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);

  // Abrir el carrito cuando el tema o una app añade un producto
  function isAdd(url) { return typeof url === 'string' && url.indexOf('/cart/add') >= 0; }
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = internal > 0;
    var res = nativeFetch.apply(this, arguments);
    if (isAdd(url) && !mine) res.then(function (r) { if (r.ok) setTimeout(open, 50); });
    return res;
  };
  if (window.jQuery) {
    window.jQuery(document).ajaxComplete(function (ev, xhr, settings) {
      if (isAdd(settings && settings.url) && xhr.status >= 200 && xhr.status < 300) setTimeout(open, 50);
    });
  }

  // El carrito se carga en segundo plano al entrar en la web, para que al abrirlo ya esté listo
  (window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); })(function () {
    if (!state.cart) getCart().then(function (cart) { if (!state.cart) { state.cart = cart; render(); } }, function () {});
  });

  window.LFCart = { open: open, close: close, refresh: refresh };
})();